export default __webpack_public_path__ + "static/image-2021-12-21-10-15-21-459-8dba98e103013a7fd32bdb5dd94f7f0d.png";